import React__default from 'react';

const width = 20;
const height = 12;
const IconLink = ({ fill = "black", size = 1 }) => {
    return (React__default.createElement("svg", { width: size * width, height: size * height, viewBox: "0 0 20 12", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React__default.createElement("path", { d: "M2 6C2 3.79086 3.79086 2 6 2H9V0H6C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12H9V10H6C3.79086 10 2 8.20914 2 6Z", fill: fill }),
        React__default.createElement("path", { d: "M6 5H14V7H6V5Z", fill: fill }),
        React__default.createElement("path", { d: "M11 0H14C17.3137 0 20 2.68629 20 6C20 9.31371 17.3137 12 14 12H11V10H14C16.2091 10 18 8.20914 18 6C18 3.79086 16.2091 2 14 2H11V0Z", fill: fill })));
};

export { IconLink as default };
//# sourceMappingURL=IconLink.js.map
